import { AfterViewInit, ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { WindowBase } from '../../../app/services/window-dialogs/window.base';

//EMAIL STUFFS
import { Subscription } from 'rxjs';
import { DialogComponent, DialogService } from "../../../app/services/modal-dialogs";
import { Title } from '@angular/platform-browser';
import { SweetAlertService } from "ng2-cli-sweetalert2";
import { MemberDashboard } from '../../../app/models/ss-api/responses/member.dashboard.response';
import { TemplatesAndFromResponse } from '../../../app/models/ss-api/responses/templates.and.from.response';
import { SendEmailRequest } from '../../../app/models/ss-api/requests/send.email.request';
import { ssApiService } from '../../../app/services/ss-api.service';

import { MemberEventsService } from '../../../app/services/member.events.service';

// CKEDITOR IMPORTS
import { CKEditorComponent, CKEditorModule } from 'ng2-ckeditor';
import { WindowEvent, WindowActionTypes } from '../../../app/services/window-dialogs/window.event';
import { TrainingEvent } from '../../../app/models/domain/training.event';
import { EmailWindowRequest, EmailWindowType } from '../../../app/models/domain/email.window.request';
import { TemplateTypes } from '../../../app/models/domain/email.template.item';
import { SendEmailForTrainingEventSubscriptionRequest } from '../../../app/models/ss-api/requests/send.email.for.training.event.subscription.request';
import { SendRealEmailsForTrainingEventRequest } from '../../../app/models/ss-api/requests/send.real.emails.for.training.event.request';
import { GISPurchaseRefundRequest } from '../../../app/models/ss-api/requests/gis.purchase.refund.request';
import { TemplateOverrides } from '../../../app/models/ss-api/requests/template.overrides.request';
import { IEmailTemplateBasicsItem, EmailTemplateBasicsItem, EmailTemplateBasicsItemArray } from '../../../app/models/domain/email.template.basics.item';
import { IfObservable } from 'rxjs/observable/IfObservable';
import { TrainingEmailEventTypes } from '../../models/ss-api/requests/training.email.event.types';

export interface emailItem {
  AdminID: number;
  Email: string;
  Name: string;
}

@Component({
  selector: 'email-window',
  styleUrls: ['./email.window.scss'],
  templateUrl: './email.window.html'
})

export class EmailWindow extends WindowBase<EmailWindowRequest> implements OnDestroy {
  IsBusy: Boolean = true;

  ticketManager: any;

  EmailOptions: EmailWindowRequest;
  MemberData: MemberDashboard = new MemberDashboard();
  TrainingEvent: TrainingEvent;
  TemplatesAndFrom: TemplatesAndFromResponse = new TemplatesAndFromResponse();
  selectedTemplate: string;
  NotificationGroupType: TrainingEmailEventTypes;

  ActiveTemplates: TemplateTypes[];

  //browser Title
  private originalTitle: string;

  //subscriptions
  private ticketOnMemberAssign: Subscription;
  private ticketOnMemberUnassign: Subscription;

  emailTo: string = "example@email.com";
  emailFrom: string = "from@email.com";

  fromEmails: any;
  selectedFromEmail: any;

  emailCc: string = "";
  emailBcc: string = "";
  emailSubject: string = "Subject";

  // EMAIL TEMPLATE STUFF
  emailTemplate: string = "";
  emailTemplatePanel: boolean = true;

  EmailMessage: string = "";
  //@ViewChild( TicketDetailsComponent ) private TicketDetails : TicketDetailsComponent;

  @ViewChild('CKEDITOR') CKEDITOR: CKEditorComponent;
  // CKEditor Config
  CKEditorConfig = {
    ID: 'emailEditor',
    name: 'emailEditor',
    allowedContent: true,
    height: '100%',
    resize_enabled: false,
    toolbarLocation: 'bottom'
  }

  // ***********************************
  // Sweet Alert Messages
  confirmTitle: string = "Send Email?";
  confirmMessage: string = "You are about to send this email. Did you double check every little thing?"

  successTitle: string = "Email Sent";
  successMessage: string = ""

  errorTitle: string = "Error";
  errorMessage: string = "We were not able to send the email.";

  cancelledTitle: string = "Cancelled";
  cancelledMessage: string = "";

  // //////////////////////////////////////////////////////////////////////////////////////////////////
  // //////////////////////////////////////////////////////////////////////////////////////////////////
  // //////////////////////////////////////////////////////////////////////////////////////////////////
  constructor(dialogService: DialogService,
    private titleService: Title,
    private changeDetect: ChangeDetectorRef,
    private sweetAlertService: SweetAlertService,
    private api: ssApiService,
    private memberService: MemberEventsService) {
    super();
  }

  Init() {
    this.EmailOptions = this.Context.Data;
    if(this.EmailOptions.Type == EmailWindowType.Member || this.EmailOptions.MemberData) {
      this.MemberData = this.EmailOptions.MemberData;
    } 
    
    if(this.EmailOptions.Type == EmailWindowType.Training) {
      this.TrainingEvent = this.EmailOptions.TrainingEvent;
    }

    if(this.EmailOptions.TrainingEmailEventType) {
      this.NotificationGroupType = this.EmailOptions.TrainingEmailEventType;
    }

    this.ActiveTemplates = this.EmailOptions.Templates;

    console.log("MemberData:", this.MemberData);
    console.log(this.TrainingEvent);
    this.IsBusy = false;

    this.emailTo = this.MemberData.Email;

    this.getTemplates();
    
    console.log(this.emailTo);

    //this.CKEDITOR.instance['emailEditor'].maximizeHeightNow();
  }

  getTemplates() {
    this.IsBusy = true;
    var subscription = this.api.GetEmailTemplatesBasicsAndFrom().subscribe(
      (response) => {
        console.log(response);
        subscription.unsubscribe();

        if (!response.Result) {
          console.log("Error", response.Message);
          this.IsBusy = false;
          return;
        }

        this.TemplatesAndFrom = response.Data;
        this.TemplatesAndFrom.Templates = this.TemplatesAndFrom.Templates.filter(function(template) {
          for(let type of this.ActiveTemplates) {
            if(template.TemplateType == type) {
              return template;
            }
          }
        }, this) as EmailTemplateBasicsItemArray;
        console.log(this.TemplatesAndFrom);
        console.log("Got Templates: ", this.TemplatesAndFrom);
        this.selectedFromEmail = this.TemplatesAndFrom.FromItems[0].Email;
        this.IsBusy = false;
        console.log(this.emailTo);

      },
      (error) => {
        console.log("Error", error);
        this.IsBusy = false;
      });
  }

  setUpFromEmails() {
    this.fromEmails = [];
    console.log("FromItems = ", this.TemplatesAndFrom.FromItems);
    this.TemplatesAndFrom.FromItems.forEach(e => {
      let newEmailItem: emailItem = {
        AdminID: e.AdminID,
        Email: e.Email,
        Name: e.Name
      };

      this.fromEmails.push(newEmailItem);
    });
  }

  ngOnDestroy() {

  }

  confirm() {
    this.IsBusy = true;

    if(this.CKEDITOR.instance['mode'] != 'wysiwyg') {
            
        this.CKEDITOR.instance['commands']['source'].exec()
        setTimeout(() => {
            this.confirm();
        }, 500)

        return false;

    }

    this.SendEmailAlert().then((response: any) => {

      console.log("RESPONSE: ")
      console.log(response);

      //init dialog vars
      let cType = "success";
      let cTitle = this.successTitle;
      let cMessage = this.successMessage;

      if (!response.Result) {
        //not ok
        cType = "error";
        cTitle = this.errorTitle;
        cMessage = this.errorMessage;
      }

      this.IsBusy = false;

      //show result
      this.sweetAlertService.swal(
        {
          title: cTitle,
          text: cMessage,
          type: cType,
          showCancelButton: false,
          showConfirmButton: false,
          timer: 2500
        })
        .then((response: any) => {
          console.log("response", response);
          this.closeOK();
        }, (dismiss) => {
          console.log("dismissed 1212", dismiss);
          this.closeOK();
          //return;
        }); //keep this line to prevent promise error;

    }, (dismiss) => {

      console.log("NO, DONT SEND IT!!!!");
      this.IsBusy = false;
      return;

    });
  }

  Relation(): string {
    if (this.ticketManager.Ticket().MemberID == -1) {
      return "Admin Name: ";
    }
    else if (this.ticketManager.Ticket().MemberID == 0) {
      return "Lead Name: ";
    }
    else {
      return "Member Name: ";
    }
  }

  closeOK() {
    // we set dialog result as true on click on confirm button, 
    // then we can get dialog result from caller code

    //this.memberService.onMemberEmailsChanged.next();
    this.InvokeEvent(WindowEvent.FromWindowContextResultOK(this.Context, WindowActionTypes.Saved, true));
    this.InvokeEvent(WindowEvent.FromWindowContextResultOK(this.Context, WindowActionTypes.Close, true));
    this.Close();
  }

  showEmailTemplatePanel() {
    console.log("showEmailTemplatePanel() Started");
    this.NotificationGroupType = null;
    this.IsBusy = true;
    this.emailTemplatePanel = true;
    this.changeDetect.detectChanges()
  }

  updateSelectedTemplate(template: string) {
    this.selectedTemplate = template;
  }

  updateEmailTemplate(newTemplate: string) {
    setTimeout( () => {
      this.emailTemplate = newTemplate;
      console.log("new email template = ", this.emailTemplate);
      this.EmailMessage = this.emailTemplate;
      console.log(this.EmailMessage);
      this.emailTemplatePanel = false;
      this.IsBusy = false;
    }, 250)
  }

  updateEmailAddress(newEmailAddress: string) {
    this.emailTo = newEmailAddress;
  }

  updateSubject(newSubject: string) {
    this.emailSubject = newSubject;
  }

  cancelEmailTemplate() {
    this.IsBusy = false;
    this.emailTemplatePanel = false;
  }

  SendEmailAlert(): Promise<any> {
    console.log(this.GetNotificationTypeForEmail(this.selectedTemplate));
    console.log(this.MemberData);
    console.log(this.TrainingEvent);
    console.log(this.emailCc);
    //confirm
    return this.sweetAlertService.swal({
      title: this.confirmTitle,
      text: this.confirmMessage,
      type: 'warning',
      showCancelButton: true,
      showCloseButton: true,
      confirmButtonText: 'Yes, Send It!',
      cancelButtonText: 'No, let me check',
      allowOutsideClick: false,
      showLoaderOnConfirm: true,
      preConfirm: () => {

        if(this.MemberData.FirstName) {
          console.log("SENDING TO THE MEMBER");
          // create new request
          var request = new SendEmailRequest();

          console.log(this.selectedFromEmail);


          // prepare fields
          request.Body = this.EmailMessage;
          request.FromEmail = this.selectedFromEmail;
          request.MemberID = this.MemberData.ID;
          request.Subject = this.emailSubject;

          // to email
          request.ToEmail = new Array<string>();
          request.ToEmail.push(this.emailTo);


          // bcc
          if (this.emailBcc != undefined && this.emailBcc != "") {
            request.ToBCC = new Array<string>();
            request.ToBCC.push(this.emailBcc);
          }

          // cc
          if (this.emailCc != undefined && this.emailCc != "") {
            request.ToCC = new Array<string>();
            request.ToCC.push(this.emailCc);
          }

          console.log(request);

          // return server request promise
          return this.api.SendEmail(request).toPromise();
        } else if(this.TrainingEvent.ID && this.MemberData.Email) {

          console.log("SENDING TO THE SUBSCRIPTION");
          let request : SendEmailForTrainingEventSubscriptionRequest = new SendEmailForTrainingEventSubscriptionRequest();
          request.TemplateOverrides = new TemplateOverrides();
          request.TemplateOverrides.OverrideMessage = this.EmailMessage;
          request.TemplateOverrides.OverrideSubject = this.emailSubject;
          request.TemplateOverrides.OverrideFrom = this.selectedFromEmail;
          request.TrainingEmailEventType = this.GetNotificationTypeForEmail(this.selectedTemplate);
          request.TrainingEventSubscriptionID = this.MemberData.ID;
          
          return this.api.SendEmailForTrainingEventSubscription(request).toPromise();

        } else if(this.TrainingEvent.ID) {

          console.log("SENDING TO THE EVENT");
          let request : SendRealEmailsForTrainingEventRequest = new SendRealEmailsForTrainingEventRequest();
          request.TrainingEmailEventType = this.GetNotificationTypeForEmail(this.selectedTemplate);
          request.TrainingEventID = this.TrainingEvent.ID;
          request.TemplateOverrides = new TemplateOverrides();
          request.TemplateOverrides.OverrideMessage = this.EmailMessage;
          request.TemplateOverrides.OverrideSubject = this.emailSubject;
          request.TemplateOverrides.OverrideFrom = this.selectedFromEmail;

          return this.api.SendRealEmailsForTrainingEvent(request).toPromise();

        }

      }
    })

  }

  GetNotificationTypeForEmail(template: string) {
    let temp = this.TemplatesAndFrom.Templates.filter(t => t.ID == parseInt(template))[0];
    let notificationGroupType;

    if(temp && temp.Name.includes('Reminder')) {
      notificationGroupType = TrainingEmailEventTypes.Training_Event_Reminder;
    } else if(temp && temp.Name.includes('NoShow')) {
      notificationGroupType = TrainingEmailEventTypes.Training_Event_NoShows;
    } else if(temp && temp.Name.includes('Certificate')) {
      notificationGroupType = TrainingEmailEventTypes.Training_Event_Certificate;
    } else if(temp && temp.Name.includes('Setup')) {
      notificationGroupType = TrainingEmailEventTypes.Training_Event_Setup;
    }

    return notificationGroupType;
  }

  insertDate(e: CKEditorComponent) {
    //console.log(e);

    this.CKEDITOR.instance['editor1'].insertHtml("<strong>Testing Insert Date</strong>");
    //this.CKEDITOR.currentInstance.insertHtml("<strong>Testing Insert Date</strong>");
  }

  Close() {
    this.InvokeEvent(WindowEvent.FromWindowContextResultOK(this.Context, WindowActionTypes.Close, true));
    window.close();
  }

}